import React from 'react'

const Filter = () => {
  return (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.75 3.50003V15.5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.5 5.74993C10.5 5.74993 12.1571 3.5 12.75 3.5C13.343 3.5 15 5.75 15 5.75" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.25 14.75L5.25 3.50003" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3 13.25C3 13.25 4.6571 15.5 5.25002 15.5C5.84294 15.5 7.5 13.25 7.5 13.25" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}

export default Filter
